import src from "IMAGE";
export default { src, width: 330, height: 263, blurWidth: 0, blurHeight: 0};
